<template>
  <div class="nav-bar">
    <div class="toolbar">
      <div class="logo" @click="navigateToHome()">
        <img src="@/assets/icon/company.png" alt="Company Logo" height="40">
        <div class="logo-title">
          <span>GrowthSoft</span>
      </div>
      </div>
      <div class="nav-links" v-if="!isMobile">
        <div class="nav-item" @click="navigateToHome()">
          <div class="text-container"> 
            <span class="main-text">{{ $t('home') }}</span>
            <span class="sub-text">{{ $t('home1') }}</span>
          </div>
          <div class="underline"></div>
        </div>
        <div class="nav-item company-overview" @click="navigateToSection('companyInfo','')" @mouseover="showCompanyOverview = true" @mouseleave="showCompanyOverview = false">
          <div class="text-container"> 
            <span class="main-text">{{ $t('companyInfo') }}</span>
            <span class="sub-text">{{ $t('companyInfo1') }}</span>
          </div>
          <div class="underline"></div>
          <transition name="fade">
            <div v-if="showCompanyOverview" class="dropdown-content">
              <ul class="dropdown-list">
                <!-- <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','achievements')">{{ $t('achievementsNavBar') }}</li> -->
                <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','vision')">{{ $t('visionNavBar') }}</li>
                <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','companyprofile')">{{ $t('companyProfileNavBar') }}</li>
                <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','welfare')">{{ $t('welfareNavBar') }}</li>
                <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','target')">{{ $t('targetNavBar') }}</li>
                <li class="dropdown-item" @click.stop="navigateToSection('companyInfo','history')">{{ $t('historyNavBar') }}</li>
              </ul>
            </div>
          </transition>
        </div>
        <div class="nav-item dropdown" @click="navigateToSection('solutionInfo','')" @mouseover="showSolutions = true" @mouseleave="showSolutions = false">
          <div class="text-container"> 
            <span class="main-text">{{ $t('solutions') }}</span>
            <span class="sub-text">{{ $t('solutions1') }}</span>
          </div>
          <div class="underline"></div>
          <transition name="fade">
            <div v-if="showSolutions" class="dropdown-content">
              <ul class="dropdown-list">
                <li class="dropdown-parent" @click.stop="activeSolution = activeSolution === 't0' ? null : 't0'" @mouseover="activeSolution = 't0'" @mouseleave="activeSolution = null">{{ $t('itsolution') }}
                  <transition name="slide">
                    <ul v-if="activeSolution === 't0'" class="dropdown-submenu" @mouseover="activeSolution = 't0'" @mouseleave="activeSolution = null">
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo','SES')">{{ $t('ses') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo','AppDev')">{{ $t('appDev') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo','Skill')">{{ $t('skill') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo','Develop')">{{ $t('develop') }}</li>
                      <!-- <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Dispatch')">{{ $t('dispatch') }}</li> -->
                    </ul>
                  </transition>
                </li>
                <!-- <li class="dropdown-parent" @click.stop="activeSolution = activeSolution === 't1' ? null : 't1'" @mouseover="activeSolution = 't1'" @mouseleave="activeSolution = null">{{ $t('t1solution') }}
                  <transition name="slide">
                    <ul v-if="activeSolution === 't1'" class="dropdown-submenu" @mouseover="activeSolution = 't1'" @mouseleave="activeSolution = null">
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work0')">{{ $t('solutionInfo.t1solution.work0') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work1')">{{ $t('solutionInfo.t1solution.work1') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work2')">{{ $t('solutionInfo.t1solution.work2') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work3')">{{ $t('solutionInfo.t1solution.work3') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work4')">{{ $t('solutionInfo.t1solution.work4') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work5')">{{ $t('solutionInfo.t1solution.work5') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work6')">{{ $t('solutionInfo.t1solution.work6') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work7')">{{ $t('solutionInfo.t1solution.work7') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work8')">{{ $t('solutionInfo.t1solution.work8') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work9')">{{ $t('solutionInfo.t1solution.work9') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work10')">{{ $t('solutionInfo.t1solution.work10') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work11')">{{ $t('solutionInfo.t1solution.work11') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work12')">{{ $t('solutionInfo.t1solution.work12') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work13')">{{ $t('solutionInfo.t1solution.work13') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work14')">{{ $t('solutionInfo.t1solution.work14') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work15')">{{ $t('solutionInfo.t1solution.work15') }}</li>
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'Work16')">{{ $t('solutionInfo.t1solution.work16') }}</li>
                    </ul>
                  </transition>
                </li> -->
                <!-- <li class="dropdown-parent" @click.stop="activeSolution = activeSolution === 't2' ? null : 't2'" @mouseover="activeSolution = 't2'" @mouseleave="activeSolution = null">{{ $t('t2solution') }}
                  <transition name="slide">
                    <ul v-if="activeSolution === 't2'" class="dropdown-submenu" @mouseover="activeSolution = 't2'" @mouseleave="activeSolution = null">
                      <li class="dropdown-item" @click.stop="navigateToSection('solutionInfo', 'T2solution')">{{ $t('t2solution') }}</li>
                    </ul>
                  </transition>
                </li> -->
              </ul>
            </div>
          </transition>
        </div>
        <div class="nav-item" @click="navigateToSection('contactInfo','')">
          <div class="text-container"> 
            <span class="main-text">{{ $t('contact') }}</span>
            <span class="sub-text">{{ $t('contact1') }}</span>
          </div>
          <div class="underline"></div>
        </div>
        <div class="nav-item" @click="navigateToSection('recruitmentInfo','')">
          <div class="text-container"> 
            <span class="main-text">{{ $t('recruitmentInfo') }}</span>
            <span class="sub-text">{{ $t('recruitmentInfo1') }}</span>
          </div>
          <div class="underline"></div>
        </div>
        <div class="nav-item dropdown" @mouseover="showDropdown = true" @mouseleave="showDropdown = false">
          <div class="text-container"> 
            <span class="main-text">{{ $t('language') }}</span>
            <span class="sub-text">{{ $t('language1') }}</span>
          </div>
          <div class="underline"></div>
          <transition name="fade">
            <div v-if="showDropdown" class="dropdown-content">
              <ul class="dropdown-list">
                <li v-for="(value, key) in languages" :key="key" class="dropdown-item" @click="changeLanguage(key)">
                  {{ value }}
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
      <div class="hamburger-menu" v-if="isMobile" @click="toggleSideNav" :class="{ 'is-active': isSideNavOpen }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    isSideNavOpen: Boolean
  },
  data() {
    return {
      showDropdown: false,
      showCompanyOverview: false,
      showSolutions: false,
      isMobile: false,
      languages: this.$i18n.messages[this.$i18n.locale].languages,
      activeSolution: false // 控制当前激活的子菜单
    };
  },
  watch: {
    '$i18n.locale'() {
      this.languages = this.$i18n.messages[this.$i18n.locale].languages;
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      sessionStorage.setItem('language', lang);
    },
    navigateToSection(router, subSectionId) {
      const targetPath = `/${router}`;
      const hash = subSectionId ? `#${subSectionId}` : '';
      const currentPath = this.$route.path;
      const currentHash = window.location.hash;

      if (currentPath !== targetPath) {
        this.$router.push(targetPath).then(() => {
          if (subSectionId) {
            location.hash = hash;
          }
        });
      } else if (currentHash !== hash) {
        this.$router.replace({ hash: hash }).then(() => {
          const element = document.getElementById(subSectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        });
      } else if (subSectionId && currentHash === hash) {
        const element = document.getElementById(subSectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    navigateToHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    toggleSideNav() {
      this.$emit('toggleSideNav');
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  mounted() {
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
    const savedLanguage = sessionStorage.getItem('language');
    if (savedLanguage) {
      this.$i18n.locale = savedLanguage;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkIfMobile);
  }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

.nav-bar {
  width: 100%;
  background-color: white;
  border-bottom: 3px solid #414c6459;
  z-index: 99;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 400;
  position: fixed;
  top: 0;
  left: 0;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.logo {
  height: 40px;
  display: flex;
  cursor: pointer;
  span {
    font-size: 23px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 8px;
    background: linear-gradient(90deg,rgb(8, 72, 11), #00dbde,rgb(11, 98, 44));
    background-size: 150% auto;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: 
      gradient 3s linear infinite;
  }

  /* 标题科技感光效 */
  .logo-title  {
    position: relative;
    display: inline-block;
    padding: 0 1em;
    color: rgba(10, 60, 17, 0.9);
    text-shadow: 0 0 2px rgba(82, 158, 105, 0.5);
  }

  .logo-title ::after {
    content: '';
    position: absolute;
    bottom: 0.5px;
    left: 50%;
    width: 90%;
    height: 2px;
    background: linear-gradient(90deg, transparent,rgb(76, 240, 114), transparent);
    transform: translateX(-50%);
    animation: laserScan 0.2s infinite;
  }
}

@keyframes gradient {
  0% { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.nav-links {
  display: flex;
  align-items: center;
}

.nav-item {
  flex-direction: column; 
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  padding: 10px 15px;
  text-decoration: none;
  color: #414c64;
}

.nav-item:hover .underline {
  width: 26%;
  left: 37%;
}

.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s, color 0.3s; /* 添加过渡动画 */
}

.nav-item:hover .text-container {
  transform: perspective(200px) rotateX(10deg); /* 3D 倾斜 */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 增加阴影 */
}

.main-text {
  font-weight: 300;
  font-size: 16px;
  color: #414c64;
  position: relative;
  z-index: 1;
}

.sub-text {
  font-weight: 200;
  font-size: 10px;
  color:rgb(255, 3, 3);
  position: relative;
  z-index: 1;
}

.sub-text::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #ff6b6b, #4a90e2);
  transition: width 0.3s;
}

.nav-item:hover .sub-text::after {
  width: 100%; /* 悬停时显示渐变色下划线 */
}

.nav-item:hover .main-text {
  transform: scale(1.1); /* 悬停时放大 */
  color:rgb(12, 93, 28); /* 悬停变色（蓝色） */
}

.nav-item:hover .sub-text {
  transform: scale(0.9); /* 副标题缩小 */
  color: #ff6b6b; /* 悬停变色（红色） */
}

.underline {
  position: absolute;
  bottom: 5px;
  left: 50%;
  width: 0;
  height: 1.5px;
  background-color:rgb(255, 255, 255);
  border-radius: 50px;
  transition: width 0.3s ease, left 0.3s ease;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color:rgb(65, 76, 100);
  color: #ffffff;
  font-size: 14px;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(-10px);
}

.nav-item:hover .dropdown-content {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-item {
  padding: 8px 16px;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color:rgb(255, 255, 255);
  color:rgb(27, 94, 8);
}

.dropdown-parent {
  background-color:rgb(65, 76, 100);
  color: #ffffff;
  position: relative;
  cursor: pointer;
  padding: 8px 20px;
  transition: background-color 0.3s;
}

.dropdown-parent:hover {
  background-color:rgb(255, 255, 255);
  color:rgb(27, 94, 8);
}

.dropdown-submenu {
  position: absolute;
  left: 100%;
  top: 0;
  background-color:rgb(65, 76, 100);
  color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  min-width: 160px;
  z-index: 1001;
}

/* 过渡动画 */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from, .slide-leave-to {
  opacity: 0;
  transform: translateX(10px);
}


.hamburger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  cursor: pointer;
  position: relative;
  z-index: 100;

  span {
    display: block;
    width: 100%;
    height: 2px;
    background-color: #414c64;
    transition: all 0.3s ease;
  }

  &.is-active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }

  &.is-active span:nth-child(2) {
    opacity: 0;
  }

  &.is-active span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }
}
</style>
